export const STATUS_IN_PROGRESS = 'IN PROGRESS'
